import {
	SEND_EMAIL_TO_PRODUCER, 
	SEND_EMAIL_TO_PRODUCER_SUCCESS, 
	SEND_EMAIL_TO_PRODUCER_FAIL 
} from "./Constants"

const initialState = {
		emailToProducerIsLoading: false,
		error: null,
		emailData: null
}
export default function reducer(state = initialState, action) {
	switch(action.type) {
		case SEND_EMAIL_TO_PRODUCER:
			return {
				...state,
					emailToProducerIsLoading: true
			}
		case SEND_EMAIL_TO_PRODUCER_SUCCESS:
			return {
				...state,
					emailToProducerIsLoading: false,
					emailData: action.payload
			}
		case SEND_EMAIL_TO_PRODUCER_FAIL:
			return {
				...state,
				emailToProducerIsLoading: false,
				error: action.payload
			}
		default:
			return state;
	}
}